// extracted by mini-css-extract-plugin
export default {"cls1":"Modal-cls1_KU4","cls2":"Modal-cls2_HwQ Modal-cls1_KU4"};